import { breadcrumb } from './breadcrumb';
import { campaign } from './campaign';
import { stats } from './stats';
import { webhook } from './webhook';
import { task } from './task';
import { operators } from './operators';
import { monitoring } from './monitoring';
import { monitoring_general } from './monitoring_general';

export const autocaller_v2 = {
  breadcrumb,
  campaign,
  stats,
  webhook,
  task,
  operators,
  monitoring,
  monitoring_general,

  produсts: {
    title: 'Produk',
    tooltip: {
      usage:
        'Ini diperhitungkan jika item "Perhitungkan keterampilan operator" dipilih dalam pengaturan kampanye'
    },
    table: {
      name: "Nama produk"
    },
    remove: 'Apakah Anda yakin ingin mencopot pemasangan produk {name}?'
  },

  validator: {
    field: {
      calls_limit: {
        max_value: 'pemanggil prediktif mendukung maks. 250 koneksi.'
      },
      date_time_error: 'Tanggal dan waktu harus lebih lambat dari saat ini dalam UTC +00:00'
    }
  }
};
